export function getUserData() {
  try {
    const stored = sessionStorage.getItem('userData');
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
}

export function isMultiplaySessionEnabled(userData) {
  const u = userData ?? getUserData();
  if (!u) return false;
  const v = u.isMultiplaySession;
  return v === true || v === 'true' || v === 1 || v === '1';
}
